import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

/* ===== CUSTOM ARROWS ===== */
function NextArrow({ onClick }) {
  return (
    <div className="custom-arrow right" onClick={onClick}>
      ❯
    </div>
  );
}

function PrevArrow({ onClick }) {
  return (
    <div className="custom-arrow left" onClick={onClick}>
      ❮
    </div>
  );
}

function HomeCustomerWalls() {
  const getSlides = () => (window.innerWidth <= 600 ? 2 : 4);

  const [slidesToShow, setSlidesToShow] = useState(getSlides());

  useEffect(() => {
    const handleResize = () => {
      setSlidesToShow(getSlides());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

const settings = {
  dots: true,
  infinite: false,         
  speed: 500,
  slidesToShow: slidesToShow,
  slidesToScroll: 1,
  arrows: true,
  swipeToSlide: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};



  return (
    <div className="home-customer-walls-bgg">
      <div className="home-customer-walls-main">
        <div className="home-customer-walls-top-heading">
          <div>Our Customers</div>
        </div>

        <div className="customer-home-walls-img-container">
          <Slider {...settings}>


            <div className="slide-item"><div className="slide-box-of-wallps-image-cols">
              <img src="https://fubs.in/cdn/shop/files/5_fddff94c-2cf6-407d-9003-85fdb029f9d3.jpg?v=1737721675" at="img1"></img>
              </div></div>

                     <div className="slide-item"><div className="slide-box-of-wallps-image-cols">
              <img src="https://fubs.in/cdn/shop/files/5_fddff94c-2cf6-407d-9003-85fdb029f9d3.jpg?v=1737721675" at="img1"></img>
              </div></div>


                          <div className="slide-item"><div className="slide-box-of-wallps-image-cols">
              <img src="https://fubs.in/cdn/shop/files/5_fddff94c-2cf6-407d-9003-85fdb029f9d3.jpg?v=1737721675" at="img1"></img>
              </div></div>


                          <div className="slide-item"><div className="slide-box-of-wallps-image-cols">
              <img src="https://fubs.in/cdn/shop/files/5_fddff94c-2cf6-407d-9003-85fdb029f9d3.jpg?v=1737721675" at="img1"></img>
              </div></div>


                          <div className="slide-item"><div className="slide-box-of-wallps-image-cols">
              <img src="https://fubs.in/cdn/shop/files/5_fddff94c-2cf6-407d-9003-85fdb029f9d3.jpg?v=1737721675" at="img1"></img>
              </div></div>


                          <div className="slide-item"><div className="slide-box-of-wallps-image-cols">
              <img src="https://fubs.in/cdn/shop/files/5_fddff94c-2cf6-407d-9003-85fdb029f9d3.jpg?v=1737721675" at="img1"></img>
              </div></div>


                          <div className="slide-item"><div className="slide-box-of-wallps-image-cols">
              <img src="https://fubs.in/cdn/shop/files/5_fddff94c-2cf6-407d-9003-85fdb029f9d3.jpg?v=1737721675" at="img1"></img>
              </div></div>


                          <div className="slide-item"><div className="slide-box-of-wallps-image-cols">
              <img src="https://fubs.in/cdn/shop/files/5_fddff94c-2cf6-407d-9003-85fdb029f9d3.jpg?v=1737721675" at="img1"></img>
              </div></div>


                          <div className="slide-item"><div className="slide-box-of-wallps-image-cols">
              <img src="https://fubs.in/cdn/shop/files/5_fddff94c-2cf6-407d-9003-85fdb029f9d3.jpg?v=1737721675" at="img1"></img>
              </div></div>

          </Slider>
        </div>
      </div>
    </div>
  );
}

export default HomeCustomerWalls;